import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import Table from "../../../../components/ui/Table/Table";
import { formatPrice } from "../../../../utils";
import { indexer } from "../../../../utils/utils";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, totalData) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, totalData);
        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.productOrderParent?.type, {
      header: "주문구분",
      cell: (info) => {
        const val = info.getValue();
        const translated = () => {
          switch (val) {
            case "AUTOMATIC_INVENTORY":
              return "자동(재고)";
            case "MANUAL_INVENTORY":
              return "수동(재고)";
            case "MANUAL_ONE_DAY_MALL":
              return "수동(원데이몰)";
            default:
              return "-";
          }
        };
        return <div>{val ? translated() : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "상태",
      cell: (info) => {
        const row = info.getValue();
        const isDone = row.orderCompletedAt !== null;
        return <div>{isDone ? "완료" : "진행중"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.productOrderParent?.orderNo, {
      header: "주문번호",
      cell: (info) => {
        const val = info.getValue();
        return <div className="line-clamp-2">{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.product?.name, {
      header: "상품명",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "주문자(담당자)",
      cell: (info) => {
        const hospitalName =
          info.row.original?.productOrderParent?.hospital?.name;
        const hospitalMemberEmail =
          info.row.original?.productOrderParent?.hospitalMember?.email;

        return (
          <div>
            <div>{hospitalName || "-"}</div>
            <div className="line-clamp-2">{hospitalMemberEmail}</div>
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.totalPrice, {
      header: "총 결제금액",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? `${formatPrice(val)}원` : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.productOrderParent?.paidType, {
      header: "결제방법",
      cell: (info) => {
        const val = info.getValue();
        const translated = () => {
          switch (val) {
            case "ACCOUNT":
              return "무통장 입금";
            case "CREDIT":
              return "신용카드";
            default:
              return "-";
          }
        };
        return <div>{val ? translated() : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.qnt, {
      header: "품목 수",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.productOrderParent?.paidCompletedAt, {
      header: "주문일시(결제일시)",
      cell: (info) => {
        const val = info.getValue();
        const datetime = dayjs(val).format("YYYY-MM-DD HH:mm");
        return <div>{val ? datetime : "-"}</div>;
      },
    }),

    columnHelper.display({
      header: "자세히보기",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = props.row.original.productOrderParent.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`/order-management/${id}`)}
      className="w-12 p-[3px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

export function HospitalOrderTable(props) {
  const { isEmpty, getDataTableProps } = props;
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().totalAll || getDataTableProps().total;
  const totalPrice = getDataTableProps().totalPrice;

  if (isEmpty) {
    return (
      <div className="flex justify-center mt-[140px] text-[#999999] text-center text-[14px]">
        등록된 주문내역이 없습니다.
      </div>
    );
  }

  return (
    <Table
      hasSave={false}
      hasPageSizeFilter={false}
      hasSort={false}
      columns={columns(currentPage, pageSize, totalData)}
      pageSize={pageSize}
      totalData={totalData}
      totalPrice={totalPrice}
      {...getDataTableProps()}
    />
  );
}
